import React from 'react';
import { MdWarning, MdClose } from 'react-icons/md';
import './ConfirmDialog.css';

// Confirm dialog — replaces window.confirm
export const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirm', confirmColor = '#EF4444' }) => {
  if (!isOpen) return null;
  return (
    <div className="dialog-overlay" onClick={onCancel}>
      <div className="dialog-box" onClick={e => e.stopPropagation()}>
        <div className="dialog-icon warning"><MdWarning /></div>
        <h3 className="dialog-title">{title}</h3>
        <p className="dialog-message">{message}</p>
        <div className="dialog-actions">
          <button className="dialog-btn cancel" onClick={onCancel}>Cancel</button>
          <button className="dialog-btn confirm" style={{ background: confirmColor }} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

// Toast notification — replaces window.alert
export const Toast = ({ toasts, removeToast }) => (
  <div className="toast-container">
    {toasts.map(toast => (
      <div key={toast.id} className={`toast toast-${toast.type}`}>
        <span className="toast-message">{toast.message}</span>
        <button className="toast-close" onClick={() => removeToast(toast.id)}><MdClose /></button>
      </div>
    ))}
  </div>
);

// Hook to manage toasts
export const useToast = () => {
  const [toasts, setToasts] = React.useState([]);

  const addToast = React.useCallback((message, type = 'info') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }, []);

  const removeToast = React.useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return { toasts, addToast, removeToast };
};

// Hook to manage confirm dialog
export const useConfirm = () => {
  const [dialog, setDialog] = React.useState({ isOpen: false });

  const confirm = React.useCallback((title, message, options = {}) => {
    return new Promise(resolve => {
      setDialog({ isOpen: true, title, message, ...options, onConfirm: () => { setDialog({ isOpen: false }); resolve(true); }, onCancel: () => { setDialog({ isOpen: false }); resolve(false); } });
    });
  }, []);

  return { dialog, confirm };
};
